import { useEffect, useState } from 'react'
import { useInteraction } from '../../../Framework/View/Hooks/useInteraction.js'
import { useProperty } from '../../../Framework/View/index.js'
import Actions, { useDispatch } from 'Flux/index.js'
import { authenticationSlice } from 'Flux/Slice/Authentication/AuthenticationSlice.js'
import { useGetAuthenticatedUser } from 'Flux/Selector/index.js'
import { useNavigate } from 'react-router-dom'

export const LoginPage = () => {
  const dispatch = useDispatch()
  const authenticatedUser = useGetAuthenticatedUser()

  const password$ = useProperty<string>('')
  const email$ = useProperty<string>('')
  const onSubmit$ = useInteraction<void>()
  const navigate = useNavigate()
  const [isNavigating, setIsNavigating] = useState<boolean>(false)

  useEffect(() => {
    dispatch(Actions[authenticationSlice.name].loginRequest())
  }, [onSubmit$, password$, email$, dispatch])

  useEffect(() => {
    console.info('login page')
    if (authenticatedUser && !isNavigating) {
      setIsNavigating(true)
      const returnTo = localStorage.getItem('postLoginRedirect')

      if (returnTo) {
        localStorage.removeItem('postLoginRedirect')
        navigate(returnTo, { replace: true })
      } else {
        //redirect('/home')
        console.info('navigate to home')
        navigate('/home')
      }
    }
  }, [authenticatedUser])

  return (
    <div className="bg-body-default w-auto h-full min-h-screen flex flex-row text-font-default">
      <div className="text-center m-auto">Redirecting to login...</div>
    </div>
  )
}
